module.exports = __webpack_public_path__ + "img/26.094d21ad.jpg";